import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Loader } from '../../_components';
import { history } from '../../_helpers';
import { momentumActions } from '../../_actions';

import { OneSignalModal } from './_components/OneSignal.modal';
import { ZenviaModal } from './_components/Zenvia.modal';
import { AmazonSesModal } from './_components/AmazonSes.modal';
import { SuperareModal } from './_components/Superare.modal';
import { WebviewModal } from './_components/Webview.modal';
import { AknaModal } from './_components/Akna.modal';
import { CellModal } from './_components/Cell.modal';

import './Channels.scss';

// Images
import Superare from '../../_assets/superare-logo.png';
import OneSignal from '../../_assets/onesignal-logo.png';
import Zenvia from '../../_assets/zenvia-logo.png';
import AmazonSES from '../../_assets/amazonses-logo.png';
import Webview from '../../_assets/webview-logo.png';
import Akna from '../../_assets/logo_akna.png';
import Cell from '../../_assets/cell_logo_colored.png';

class ChannelsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeChannels: [],
      availableChannels: [
        {
          channel: 'CELL_NOTIFICATION',
          name: "Cellit.io",
          image: Cell,
          icon: 'lnr-alarm',
          subtitle: 'Impacte seus usuários através de notificações push',
          type: 'cellChannel',
          view: false,
          edit: false
        },
        // {
        //   channel: 'ONE_SIGNAL',
        //   name: 'OneSignal',
        //   image: OneSignal,
        //   icon: 'lnr-alarm',
        //   subtitle: 'Impacte seus usuários através de notificações',
        //   type: 'onesignalChannel',
        //   view: true,
        //   edit: true
        // },
        {
          channel: 'ZENVIA',
          name: 'Zenvia',
          image: Zenvia,
          icon: 'lnr-bubble',
          subtitle: 'Impacte seus usuários através de SMS',
          type: 'zenviaChannel',
          view: true,
          edit: true
        },
        {
          channel: 'AWS_SES',
          name: 'AmazonSES',
          image: AmazonSES,
          icon: 'lnr-envelope',
          subtitle: 'Impacte seus usuários através de E-mail',
          type: 'amazonSesChannel',
          view: true,
          edit: true
        },
        {
          channel: 'AKNA',
          name: 'Akna',
          image: Akna,
          icon: 'lnr-envelope',
          subtitle: 'Impacte seus usuários através de E-mail',
          type: 'aknaChannel',
          view: true,
          edit: true
        },
        {
          channel: 'SUPERARE_WEBVIEW',
          name: 'Webview',
          image: Webview,
          icon: 'linearicons-laptop-phone',
          subtitle: 'Impacte seus usuários através de Webview',
          type: 'webviewChannel',
          view: true,
          edit: false
        }
      ],
      listed: false,
      domain: queryString.parse(this.props.location.search).domain,
      updating: true,
      actionType: null
    }

    this.handleAction = this.handleAction.bind(this);
  }

  handleSubmit() {
    const { dispatch } = this.props;
    dispatch(momentumActions.listAvailableChannels(this.state.domain))
      .then(res => {
        if ( res.type === 'ALERT_FAILURE' ) return;
        this.setState({
          activeChannels: res.data.data, 
          updating: false,
          actionType: 'view'
        });
      });
  }

  handleAction(e) {
    const target = e.currentTarget;

    this.setState({
      actionType: target.getAttribute('data-action')
    });
  }

  componentDidMount() {
    document.title = "Channels - Cellit.io";

    const { dispatch } = this.props;
    dispatch(momentumActions.listAvailableChannels(this.state.domain))
      .then(res => {
        if ( res.type === 'ALERT_FAILURE' ) return;
        this.setState({activeChannels: res.data.data, updating: false});
      });
  }

  render() {
    return(
      <section key={this.state.domain} className="component component-channels">
        <div className="component-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <h1 className="title">Canais</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="component-body">
          {
            !this.state.updating ?
              <div className="container-fluid">
                <div className="row">
                  {
                    this.state.availableChannels.length !== 0 ?
                      this.state.availableChannels.map((channel, index) => {
                        let isActive = false;
                        
                        if ( this.state.activeChannels.find(ac => ac.channel_type === channel.channel) ) {
                          isActive = true;
                        }

                        let config = false;
                        if ( channel.channel === "CELL_NOTIFICATION" ) {
                          config = true;
                        }
                        
                        return <ChannelGroup icon={channel.icon} imgSrc={channel.image} subtitle={channel.subtitle} channelType={channel.type} active={isActive} view={channel.view} edit={channel.edit} evt={this} config={config}/>
                      })
                    : null
                  }
                </div>
              </div>
            : <Loader />
          }
        </div>

        {
          !this.state.updating ?
            <div>
              <OneSignalModal name="onesignalChannel" activeChannels={this.state.activeChannels} evt={this} actionType={this.state.actionType} />
              <ZenviaModal name="zenviaChannel" activeChannels={this.state.activeChannels} evt={this} actionType={this.state.actionType}/>
              <AmazonSesModal name="amazonSesChannel" activeChannels={this.state.activeChannels} evt={this} actionType={this.state.actionType}/>
              <SuperareModal name="superareChannel" activeChannels={this.state.activeChannels} evt={this} actionType={this.state.actionType} />
              <WebviewModal name="webviewChannel" activeChannels={this.state.activeChannels} evt={this} actionType={this.state.actionType}/>
              <AknaModal name="aknaChannel" activeChannels={this.state.activeChannels} evt={this} actionType={this.state.actionType}/>
              <CellModal name="cellChannel" activeChannels={this.state.activeChannels} evt={this} actionType={this.state.actionType}/>
            </div>
          : ''
        }
      </section>
    )
  }
}

class ChannelGroup extends Component {
  handleModalOpen(e) {
    let _ = e.target;

    if ( !_.checked ) {
      return _.setAttribute('data-target', '#'+_.getAttribute('name')+'Modal');
    }

    _.setAttribute('data-target', '');
  }

  render() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
        <div className="channel-card-group" data-active="true">
          <div className="row">
            <div className="col-1">
              <i className={'info-ico lnr ' + this.props.icon}></i>
            </div>
            <div className="col">
              {
                this.props.title ?
                  <p className="channel-title">{this.props.title}</p>
                : <img src={this.props.imgSrc} className="channel-title-image" alt={this.props.title + ' logo'}/>
              }
              <p className="channel-subtitle">{this.props.subtitle}</p>
            </div>
            <div className="col-2">
              {
                this.props.active ?
                  <input type="checkbox" name={this.props.channelType} id={this.props.channelType} checked disabled />
                : <input type="checkbox" name={this.props.channelType} id={this.props.channelType} data-toggle="modal" data-target={'#'+this.props.channelType+'Modal'} onChange={this.handleModalOpen} data-action={null} onClick={this.props.evt.handleAction.bind()} />
              }
              <label htmlFor={this.props.channelType}></label>
              {
                this.props.active ?
                <div>
                  {
                    this.props.view ?
                    <button className="see-info" data-toggle="modal" data-target={'#'+this.props.channelType+'Modal'} data-action='view' onClick={this.props.evt.handleAction.bind()}>
                      <i className="lnr lnr-eye"></i>
                    </button>
                    : ''
                  }
                  { 
                    this.props.edit ?
                    <button className="edit-info" data-toggle="modal" data-target={'#'+this.props.channelType+'Modal'} data-action='edit' onClick={this.props.evt.handleAction.bind()}>
                      <i className="lnr lnr-pencil"></i>
                    </button>
                    : ''
                  }
                  {
                    this.props.config ?
                      <button
                        className="edit-info"
                        data-toggle="modal"
                        data-target={`#${this.props.channelType}Modal`}
                        data-action="code"
                        onClick={this.props.evt.handleAction.bind()}
                      >
                        <i className="linearicons-code"></i>
                      </button>
                    : null
                  }
                </div>
                : ''
              }
            </div>
          </div>
        </div>                
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { listedChannels } = state.listChannelsReducer;
  return listedChannels;
}

const ConnectedChannelsContainer = connect(mapStateToProps)(ChannelsContainer);
export { ConnectedChannelsContainer as ChannelsContainer }